<template>
    <div>
        <Loading2
            :isLoading="isLoading"
            :textList="['LOADING...','正在核對身份','連線讀取資料中']"
        >
            <div class="loading-animation scale-50">
                <div />
                <div />
                <div />
            </div>
            <p class="pb-2 text-gray-900 text-lg font-bold">
                前往線上交易專區
            </p>
        </Loading2>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Loading2 from '@/components/Loading2.vue';
import routeName from '@/router/constant.js';

export default {
    components: {
        Loading2,
    },
    setup() {
        const isLoading = ref(false);
        const router = useRouter();
        const route = useRoute();
        const store = useStore();

        if (route.query.questNo) {
            store.dispatch('services/setQuestNoIQ', route.query.questNo);
            router.push({ name: routeName.REDIRECTING_IQ }).catch(err => { console.log(err); });
        } else {
            router.push({ name: routeName.HOME });
        }
        onMounted(() => {
            isLoading.value = true;
        });

        return {
            isLoading
        };
    }
};
</script>
